import { ParseKeys } from 'i18next'
import { LocaleEnum } from 'shared/enums/locale-enum'

export interface MenuItemsInterface {
  sectionTitle: ParseKeys
  items: BottomMenuItemInterface[]
}

export interface BottomMenuItemInterface {
  title: ParseKeys | string
  href: string
  noLoco?: boolean
  excludeLocales?: LocaleEnum[]
  allLoco?: boolean
}

export const bottomMenuItems: MenuItemsInterface[] = [
  {
    sectionTitle: 'public.public_footer.product.title',
    items: [
      {
        title: 'public.public_footer.product.sales_funnels',
        href: '/sales-funnels',
      },
      { title: 'public.public_footer.product.email_marketing', href: '/email-marketing' },
      { title: 'public.public_footer.product.website_builder', href: '/website-builder' },
      { title: 'public.public_footer.product.affiliate_management', href: '/affiliate-management' },
      { title: 'public.public_footer.product.marketing_automation', href: '/marketing-automation' },
      { title: 'public.public_footer.product.online_course_builder', href: '/online-courses' },
      { title: 'public.public_footer.product.templates_library', href: '/templates' },
      {
        title: 'public.public_footer.product.suggest_feature',
        href: 'https://roadmap.systeme.io/',
        noLoco: true,
      },
    ],
  },
  {
    sectionTitle: 'public.public_footer.info.title',
    items: [
      {
        title: 'public.public_footer.info.pricing',
        href: '/pricing',
      },
      {
        title: 'public.public_footer.info.testimonials',
        href: '/testimonials',
        excludeLocales: [LocaleEnum.DEUTSCH, LocaleEnum.RUSSIAN, LocaleEnum.JAPANESE],
      },
      { title: 'public.public_footer.info.free_migration', href: '/free-migration' },
      { title: 'Become an affiliate', href: '/affiliate-program' },
      {
        title: 'public.public_footer.info.receive_your_award',
        href: '/awards',
        excludeLocales: [LocaleEnum.RUSSIAN, LocaleEnum.JAPANESE],
      },
      { title: 'public.public_footer.info.help', href: '/help' },
    ],
  },
  {
    sectionTitle: 'public.public_footer.legal.title',
    items: [
      {
        title: 'public.public_footer.legal.imprint',
        href: '/disclaimer-legal-notice',
        excludeLocales: [
          LocaleEnum.ENGLISH,
          LocaleEnum.PORTUGUESE,
          LocaleEnum.FRENCH,
          LocaleEnum.SPANISH,
          LocaleEnum.ITALIAN,
          LocaleEnum.DUTCH,
          LocaleEnum.JAPANESE,
          LocaleEnum.RUSSIAN,
        ],
      },
      {
        title: 'public.public_footer.legal.privacy_policy',
        href: '/privacy-policy',
      },
      { title: 'public.public_footer.legal.terms_and_conditions', href: '/terms-and-conditions' },
      {
        title: 'public.public_footer.legal.affiliate_agreement',
        href: '/affiliate-agreement',
        excludeLocales: [LocaleEnum.RUSSIAN],
      },
    ],
  },
]
